import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionMatchingAnswerItemSchema = z.object({
  id: z.string(),
  content: z.string().min(1, 'Opis jest wymagany').max(512),
});

export const questionMatchingAnswerPairSchema = z.object({
  left: questionMatchingAnswerItemSchema,
  right: questionMatchingAnswerItemSchema,
  points: z.number('Punkty są wymagane').positive('Punkty muszą być liczbą dodatnią'),
  explanation: z.string().optional(),
});

export const questionMatchingSchema = questionBaseSchema.extend({
  type: z.literal(QuestionType.MATCHING),
  answers: z.array(questionMatchingAnswerPairSchema).min(2, 'Minimum 2 pary odpowiedzi').max(10, 'Maksimum 10 par odpowiedzi'),
});

export type QuestionMatchingAnswerPairSchema = Infer<typeof questionMatchingAnswerPairSchema>;
export type QuestionMatchingAnswerItemSchema = Infer<typeof questionMatchingAnswerItemSchema>;

export type QuestionMatchingSchema = Infer<typeof questionMatchingSchema>;
